<app-moveable-panel>
  <div class="flex flex-col">
    <app-movable-panel-title>
      <div class="grow flex items-center justify-between gap-4">
        <span>{{ 'multi-site-dashboard.energy-cost-overview.title' | translate }}</span>
        <div class="flex items-center gap-2">
          <app-multi-select type="single" [options]="rangeOptions()" [ngModel]="range()" (ngModelChange)="onRangeChange($event)" />
          <ng-content></ng-content>
        </div>
      </div>
    </app-movable-panel-title>

    @if (isLoading()) {
      <app-energy-cost-overview-movable-panel-loading-skeleton />
    } @else if (vm()) {
      @let viewModel = vm()!;
      <div class="flex px-2">
        <div class="grow min-w-0 flex flex-col px-6 py-4 rounded-radius-container bg-background-container-primary">
          <ng-template #weatherIcon let-data>
            @let weather = getWeather(data);
            <div class="flex flex-col items-center pointer-events-none">
              <div class="flex flex-col translate-y-[-100%] min-h-5">
                @if (
                  viewModel.chartData.length <= 14 && weather?.temperatureCelsius !== null && weather?.temperatureCelsius !== undefined
                ) {
                  <span class="text-[11px] text-foreground-primary-60 whitespace-nowrap">
                    {{ weather?.temperatureCelsius | number: '1.0-1' }}{{ 'common.celsius' | translate }}
                  </span>
                }
                <app-weather-display [icon]="weather?.icon" />
              </div>
            </div>
          </ng-template>

          <ng-template #weatherCursorTooltip let-data>
            @let weather = getWeather(data);
            <div class="flex flex-col">
              <div
                class="translate-y-[-100%] flex min-h-5 items-center rounded-radius-container bg-background-container-primary drop-shadow-foreground-primary-100-shadow-30 px-2 py-1 pointer-events-none"
              >
                <app-weather-display [icon]="weather?.icon" [temperatureCelsius]="weather?.temperatureCelsius" [details]="true" />
              </div>
            </div>
          </ng-template>

          @if (chartConfig(); as config) {
            <app-chart class="grow min-w-0 h-[260px]" [config]="config" />
          }
        </div>
      </div>
      <app-energy-cost-overview-legend [sites]="viewModel.sites" [isEnergyAggregated]="viewModel.isEnergyAggregated" />
    }

    <div class="flex items-center justify-end p-4">
      <a [routerLink]="[RouteSegment.Root, RouteSegment.Sites]">
        <app-panel-link [label]="'multi-site-dashboard.view-sites' | translate"></app-panel-link>
      </a>
    </div>
  </div>
</app-moveable-panel>
